import PageLayer from "@Layouts/views/PageLayer";

// Control Context
import { DataControlProvider } from "@/Common/context/dataControl";

// Layer
import CRMLayer from "@/DataPages/components/CRM/CRMLayer";

// Icons
import CRMIcon from "@/assets/icons/dataPages/crm/CRM.svg";

export default function CRM() {
	return (
		<PageLayer title={"Customer Relations"} icon={CRMIcon}>
			<DataControlProvider>
				<CRMLayer />
			</DataControlProvider>
		</PageLayer>
	);
}
